module.exports = "dist/images/block-hero-block-plain.aeb4b5d.png";